import React, { useState, useEffect, useRef } from "react"
import { createPortal } from "react-dom"
import Airtable from "airtable"
import { Router, Redirect } from "@reach/router"
import "../styles/App.scss"
import kila from "../static/kila.png"
//UI components
import HomeHeader from "../components/HomeHeader"
import Footer from "../components/Footer"
//Utils
import usePortal from "../utils/usePortal"

const Login = () => {
  const [redirect, setRedirect] = useState(false)

  return (
    <div id="grid-parent">
      <Router>
        {redirect && <Redirect from="/" to="/kila-home-id-980615" />}
      </Router>
      <HomeHeader />
      <Form setRedirect={setRedirect} />
      <Footer />
    </div>
  )
}

const Form = ({ setRedirect, id }) => {
  let [mails, setMails] = useState([])
  let [userMail, setUserMail] = useState("")
  let [userPass, setUserPass] = useState("")

  const form = useRef(null)
  const [error, setError] = useState(false)

  const findEmails = () => {
    let base = new Airtable({ apiKey: "keyRICOfYlRaLgFzw" }).base(
      "appLpc9Ewre2aXiiz"
    )

    base("Correos de Acceso")
      .select({
        fields: ["CORREO", "CONTRASEÑA", "STATUS"],
        view: "Grid view",
      })
      .eachPage(
        function page(records, fetchNextPage) {
          let temp = []
          records.forEach(function (record) {
            if (record.get("CORREO") !== undefined) {
              //Se almacenan los correos en el arreglo correspondiente
              setMails(items => [
                ...items,
                [
                  record.get("CORREO"),
                  record.get("CONTRASEÑA"),
                  record.get("STATUS"),
                ],
              ])
            }
          })

          fetchNextPage()
        },
        function done(err) {
          if (err) {
            console.error(err)
            return
          }
        }
      )
  }

  const userInput = event => {
    setUserMail(event.target.value)
  }

  const passInput = event => {
    setUserPass(event.target.value)
  }

  const verifyEmail = event => {
    event.preventDefault()

    mails.forEach(elem => {
      if (
        userMail === elem[0] &&
        userPass === elem[1] &&
        elem[2] === "Activo"
      ) {
        setRedirect(true)
      } else if (
        (userMail === elem[0] &&
          userPass === elem[1] &&
          elem[2] === "Bloqueado") ||
        (userMail !== elem[0] && userPass !== elem[1])
      ) {
        if (error) {
          setError(false)
        } else {
          setError(true)
        }

        form.current.reset()
      }
    })
  }

  useEffect(() => {
    findEmails()
  }, [])

  return (
    <>
      {error ? (
        <Modal id={id}>
          <div className="modal-container">
            <div className="error-modal">
              <p>
                Acceso Restringido{" "}
                <span role="img" aria-label="warning">
                  ⚠️
                </span>
              </p>
            </div>
          </div>
        </Modal>
      ) : (
        <></>
      )}
      <div className="login-container">
        <form ref={form} className="login-box">
          <div className="img-box">
            <img src={kila} alt="kila logo" />
          </div>
          <label htmlFor="email">Correo de Acceso</label>
          <input
            required
            id="email"
            type="email"
            className="validate"
            placeholder="Ingresa tu correo para acceder"
            onChange={userInput}
          />
          <label style={{ marginTop: "1rem" }} htmlFor="email">
            Contraseña
          </label>
          <input
            required
            id="password"
            type="password"
            className="validate"
            placeholder="Ingresa tu contraseña"
            onChange={passInput}
          />
          <span>
            <button type="submit" onClick={verifyEmail}>
              Ingresar
            </button>
          </span>
        </form>
      </div>
    </>
  )
}

/* 
  Modal personalizado para enviar 
  respuesta después del submit
*/
const Modal = ({ id, children }) => {
  const target = usePortal(id)

  return createPortal(children, target)
}

export default Login
